import { useContext, useEffect, useState, ComponentProps } from 'react';
import { connect } from 'react-redux';
import { useUnmountPromise } from 'react-use';

import * as actions from '../../../vehicles/store/actions';
import { FormContext, SelectInput } from '../forms';

/** Минимальный структурный тип элемента справочника поколений (готового интерфейса в vehicles/api нет). */
interface VehicleGenerationItem {
  id: string | number,
  name?: string,
}

type VehicleGenerationSelectorProps = Omit<ComponentProps<typeof SelectInput>,
  'value' | 'defaultValue' | 'onChange'> &{
  modelId?: string | number,
  disabled?: boolean,
  onChange?: (event: any) => void,
  /** из mapStateToProps */
  generations?: VehicleGenerationItem[],
  /** из mapDispatchToProps */
  getVehicleGenerations: (modelId?: string | number) => Promise<unknown>,
};

const VehicleGenerationSelector = (props: VehicleGenerationSelectorProps) => {
  const mounted = useUnmountPromise();
  // FormContext создаётся в utils.js без дженерика — приводим к нужной форме (см. SelectInput.tsx)
  const { handleChange } = useContext(FormContext) as { handleChange?: (event: any) => void };
  const {
    disabled,
    modelId,
    generations,
    getVehicleGenerations,
    onChange,
    name = 'generationId',
    ...rest
  } = props;

  const [loading, setLoading] = useState(false);

  const loadData = (): Promise<unknown> => {
    if (modelId) {
      setLoading(true);

      return getVehicleGenerations(modelId).finally(() => setLoading(false));
    }

    return Promise.resolve();
  };

  useEffect(() => {
    mounted(loadData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelId]);

  return (
    <SelectInput
      { ...rest }
      name={ name }
      data={ generations }
      dataTitle='name'
      dataValue='id'
      loading={ loading }
      disabled={ disabled || loading }
      onChange={ (event) => { handleChange(event);if (typeof onChange === 'function') onChange(event); } }
      sort
    />
  );
};

const mapStateToProps = (state) => {
  return {
    generations: state.vehicles?.generations,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVehicleGenerations: payload => dispatch(actions.getVehicleGenerations(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleGenerationSelector);
